import { render, staticRenderFns } from "./WebphoneTelnyx.vue?vue&type=template&id=935ec77a&scoped=true"
import script from "./WebphoneTelnyx.vue?vue&type=script&lang=js"
export * from "./WebphoneTelnyx.vue?vue&type=script&lang=js"
import style0 from "./WebphoneTelnyx.vue?vue&type=style&index=0&id=935ec77a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935ec77a",
  null
  
)

export default component.exports